import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export default function DebugLogin() {
  const navigate = useNavigate();
  const { login, user } = useAuth();
  const [email, setEmail] = useState('client@kosha.com');
  const [password, setPassword] = useState('password123');
  const [log, setLog] = useState([]);
  const [loading, setLoading] = useState(false);

  const addLog = (message) => {
    setLog(prev => [...prev, `${new Date().toLocaleTimeString()}: ${message}`]);
  };

  const handleLogin = async () => {
    setLoading(true);
    addLog('Starting login...');
    
    try {
      addLog(`Calling login with ${email}`);
      const result = await login(email, password);
      
      addLog(`Login result: ${JSON.stringify(result)}`);
      
      if (result.success) {
        addLog(`✅ Login successful!`);
        addLog(`User: ${JSON.stringify(result.user)}`);
        addLog(`Role: ${result.user?.role}`);
        
        const userRole = result.user?.role || 'client';
        let targetPath;
        
        switch(userRole) {
          case 'admin':
            targetPath = '/admin/dashboard';
            break;
          case 'agent':
            targetPath = '/agent/dashboard';
            break;
          case 'agency':
            targetPath = '/agency/dashboard';
            break;
          case 'business':
            targetPath = '/business/dashboard';
            break;
          default:
            targetPath = '/dashboard';
        }
        
        addLog(`Redirecting to: ${targetPath}`);
        
        setTimeout(() => {
          navigate(targetPath);
        }, 2000);
      } else {
        addLog(`❌ Login failed: ${result.error}`);
      }
    } catch (error) {
      addLog(`❌ Error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background p-8">
      <div className="max-w-2xl mx-auto space-y-6">
        <Card>
          <CardHeader>
            <CardTitle>Debug Login Test</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-1">Email</label>
              <Input 
                type="email" 
                value={email} 
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium mb-1">Password</label>
              <Input 
                type="password" 
                value={password} 
                onChange={(e) => setPassword(e.target.value)}
                disabled={loading}
              />
            </div>
            
            <Button onClick={handleLogin} disabled={loading} className="w-full">
              {loading ? 'Logging in...' : 'Test Login'}
            </Button>

            <div className="mt-4 p-4 bg-muted rounded">
              <h3 className="font-semibold mb-2">Current Auth State:</h3>
              <pre className="text-xs overflow-auto">
                {JSON.stringify({ user, localStorage: {
                  access_token: localStorage.getItem('access_token') ? 'EXISTS' : 'MISSING',
                  user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : 'MISSING'
                }}, null, 2)}
              </pre>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Debug Log</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="bg-black text-green-400 p-4 rounded font-mono text-xs h-64 overflow-auto">
              {log.map((entry, i) => (
                <div key={i}>{entry}</div>
              ))}
              {log.length === 0 && <div className="text-gray-500">No log entries yet...</div>}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
